var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"osmMap",style:({ width: '100%', height: _vm.height }),attrs:{"id":_vm.idOverride ? _vm.idOverride : 'osm-map'}})
}
var staticRenderFns = []

export { render, staticRenderFns }